const getDestination = ({ address1, city, state, zipcode } = {}) =>
  encodeURIComponent(`${address1}, ${city || ''}, ${state || ''} ${zipcode || ''}`)

const googleMapRouteUrl = (
  { from, to },
  travelMode = 'driving'
) => `https://www.google.com/maps/dir/?api=1&travelmode=${travelMode}${from ? `&origin=${from.latitude},${from.longitude}` : ''}${to ? `&destination=${getDestination(to)}` : ''}`

export default googleMapRouteUrl
